import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import { DataGrid } from '@mui/x-data-grid';
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import Api from '../../../../utils/Api';

export default function ChoixElevePopup({
    isOpen,
    onClose,
    selectedEleves,
    setSelectedEleves
}) {
    const [elevesLoaded, setElevesLoaded] = useState([]);
    const [elevesAffichage, setElevesAffichage] = useState([]);

    const [search, setSearch] = useState("");
    const [scroll, setScroll] = useState('paper');

    useEffect(() => {
        if (!isOpen) return;

        Api.get('/user/active/1').then(res => {
            setElevesLoaded([...res.data.users]);
        });

        setScroll('paper');
    }, [isOpen]);

    /**
     * useEffect qui peuple le tableau d'affichage des étudiants à partir de la liste d'étudiants chargés
     * 
     * @author: Félix Dupras-Simard [felixdupras@gmail.com]
     * D'après le code de projet-ebadge
     * Inspiré de la documentation de MUI - https://mui.com/x/react-data-grid/ - [Consulté le 26 mars 2026]
     */
    useEffect(() => {
        const rows = elevesLoaded.map((eleve, index) => (
            {
                id: eleve.id ?? index,
                prenomUtilisateur: eleve.first_name,
                nomUtilisateur: eleve.last_name,
                emailUtilisateur: eleve.email,
                roleUtilisateur: eleve.role_id,
            }));
        setElevesAffichage(rows.filter((eleve) => eleve.roleUtilisateur === 4));
    }, [elevesLoaded]);

    const columns = [
        { field: 'prenomUtilisateur', headerName: 'Prénom', editable: false },
        { field: 'nomUtilisateur', headerName: 'Nom', editable: false },
        { field: 'emailUtilisateur', headerName: 'Email', editable: false },
    ]

    /**
     * Ferme la fenêtre et réinitialise les valeurs
     */
    const handleCancel = () => {
        onClose();
    };

    const handleSubmit = () => {
        onClose();
    };

    /**
     * Fonction qui permet de filtrer les badges selon le nom entré dans le search
     * 
     * @author: Félix Dupras-Simard [felixdupras@gmail.com]
     */
    // const badgesFiltreNom = badgesLoaded.filter((badge) => {
    //     const searchTerme = search.toLowerCase();
    //     return badge.title.toLowerCase().startsWith(searchTerme);
    // });

    /**
     * Visuel pour l'affichage des étudiants disponibles à l'assignation
     * 
     * @author: Félix Dupras-Simard [felixdupras@gmail.com]
     * D'après le code de projet-ebadge
     * Inspiré de la documentation de MUI - https://mui.com/x/react-data-grid/ - [Consulté le 26 mars 2026]
     */
    return (
        <Dialog open={isOpen} onClose={handleCancel} scroll={scroll} maxWidth="md" fullWidth>
            <DialogTitle>Sélection des élèves</DialogTitle>
            <DialogContent dividers={scroll === 'paper'}>
                <Box sx={{ mb: 2 }}>
                    <DataGrid
                        rows={elevesAffichage}
                        columns={columns}
                        checkboxSelection

                        // Inspiré de ClaudeAI - [Modèle massif de langage] - claude.ai - [Consulté le 31 mars 2026]
                        rowSelectionModel={selectedEleves.map((e) => e.id)}
                        onRowSelectionModelChange={(newSelectionIds) => {
                            const selectedObjects = elevesLoaded.filter((e) =>
                                newSelectionIds.includes(e.id)
                            );
                            setSelectedEleves(selectedObjects);
                        }}
                        // Fin de l'inspiration de ClaudeAI - [Modèle massif de langage] - claude.ai

                        pageSizeOptions={[5]}
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 5, page: 0 },
                            },
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit}>Soumettre</Button>
                <Button onClick={handleCancel}>Annuler</Button>
            </DialogActions>
        </Dialog >
    );
}